<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-01 17:28:19
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-staff-relation-config')"
                       :show_del="hasBtn('delete-staff-relation-config')"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <staffOfficial :disabled='readonly'
                   @changeReadonly='handleEdit'></staffOfficial>
  </div>
</template>

<script>
import {
  staff_relation_config_delete,
} from '@/service/api/staffRelationConfig.js'
import staffOfficial from './staffRelationConfig.vue'
export default {
  components: {
    staffOfficial
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {},
  created () {
  },
  watch: {
    readonly: {
      handler (v) {

        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_staff_correlation_config'
          this.$store.commit('set_page_title', 'label_edit_staff_correlation_config')
        }
        else {
          this.$route.meta.title = 'label_view_staff_correlation_config'
          this.$store.commit('set_page_title', 'label_view_staff_correlation_config')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        staff_relation_config_delete({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'staffRelationConfig',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
